import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AccountLinkInvite from "../account-link/AccountLinkInvite";
import AccountLinkSearch from "../account-link/AccountLinkSearch";
import AccountLinkHome from "../account-link/AccountLinkHome";
import AccountLinkUploadFiles from "../account-link/AccountLinkUploadFiles";
import AccountLinkDocumentsSent from "./../account-link/AccountLinkDocumentsSent";
import { setStepParticipant, getRelationshipsParticipant } from "./../../../actions/account-link";
import { refreshOffers } from "./../../../actions/index";

class AccountLink extends Component {
	constructor() {
		super();
		this.state = {
			termAccepted: false,
			inviteAccepted: false,

			currentStep: 0
		};

		this.acceptTerms = this.acceptTerms.bind(this);
		this.acceptInvite = this.acceptInvite.bind(this);

		this.incStep = this.incStep.bind(this);
		this.decStep = this.decStep.bind(this);
	}

	acceptTerms() {
		this.setState({ termAccepted: true });
	}

	acceptInvite() {
		this.setState({ inviteAccepted: true });
	}

	componentDidMount() {
		const { dataLink, dataOffers, loadingOffers } = this.props;

		if (!loadingOffers && !dataOffers) {
			this.props.refreshOffers();
		}

		if (
			(dataLink && dataLink.some(link => link.status.subStatus != "inviteSendParticipant")) ||
			localStorage.getItem("showWelcomeScreen") == "1"
		) {
			this.setState({ currentStep: 1 });
		}
	}

	componentWillMount() {
		this.props.getRelationshipsParticipant();
	}

	incStep() {
		const { termAccepted, inviteAccepted } = this.state;
		let currentStep = this.state.currentStep;
		currentStep++;

		if (currentStep == 5) {
			this.props.getRelationshipsParticipant();
			currentStep = 1;
		}

		if (inviteAccepted) {
			currentStep = 3;
		} else if (termAccepted) {
			currentStep = 1;
		}

		this.setState({ currentStep });
	}

	// Para voltar o step
	decStep() {
		const { termAccepted, inviteAccepted } = this.state;
		let currentStep = this.state.currentStep;

		currentStep--;

		this.setState({ currentStep });
	}

	renderStep() {
		const { dataOffers, loadingOffers } = this.props;
		let { currentStep } = this.state;

		switch (currentStep) {
			case 0:
				return <AccountLinkInvite onConfirm={this.acceptTerms} incStep={this.incStep} />;
			case 1:
				return (
					<AccountLinkHome
						loadingOffers={loadingOffers}
						dataOffers={dataOffers}
						onConfirm={this.acceptInvite}
						incStep={this.incStep}
					/>
				);
			case 2:
				return <AccountLinkSearch decStep={this.decStep} incStep={this.incStep} />;
			case 3:
				return <AccountLinkUploadFiles decStep={this.decStep} incStep={this.incStep} />;
			case 4:
				return <AccountLinkDocumentsSent decStep={this.decStep} incStep={this.incStep} />;
			default:
				return <AccountLinkInvite incStep={this.incStep} />;
		}
	}

	render() {
		return <section className="account-link row no-margin">{this.renderStep()}</section>;
	}
}

const mapStateToProps = state => ({
	...state.accountLink,
	dataOffers: state.offers.data,
	loadingOffers: state.offers.loading,
	dataLink: state.accountLink.dataRelationshipParticipant
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			getRelationshipsParticipant,
			refreshOffers
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AccountLink);
